import React from "react";

export const Badge = ({ color, className, children, wrapText }) => {
  return (
    <div className={"status_tag__container" + (className ? " " + className : "")}>
      <div className={`status_tag__indicator status_tag__indicator--${color}`}></div>
      <div className={"t--sm" + (wrapText ? "" : "t--nowrap")}>{children}</div>
    </div>
  );
};
